module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "LIST OF ABBREVIATIONS FOR FREQUENTLY CITED SOURCES"
    }
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253039767_Contents#rabb"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_c('b', [_vm._v("ABBREVIATIONS FOR FREQUENTLY CITED SOURCES")])])])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Werke")])])]), _vm._v(" "), _c('td', {
    staticClass: "td",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Hermann Cohen, "), _c('i', [_vm._v("Hermann Cohens Werke")]), _vm._v(", ed. H. Holzhey, 17 vols. (New York: G. Olms, 1978–).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("KS")]), _vm._v(" 1–6")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Hermann Cohen, "), _c('i', [_vm._v("Hermann Cohens Werke")]), _vm._v(", "), _c('i', [_vm._v("Kleinere Schriften")]), _vm._v(", vols. 12–17 of "), _c('i', [_vm._v("Werke")]), _vm._v(", 6 vols.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("KBE")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Hermann Cohen, "), _c('i', [_vm._v("Kants Begrundung der Ethik")]), _vm._v(" (Berlin: F. Dümmler, 1877; repr. in "), _c('i', [_vm._v("Werke")]), _vm._v(" 2).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("LrE")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Hermann Cohen, "), _c('i', [_vm._v("System der Philosophie, Erster Teil: Logik der reinen Erkenntnis")]), _vm._v(" (Berlin: Bruno Cassirer, 1902; repr. in "), _c('i', [_vm._v("Werke")]), _vm._v(" 6).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("ErW")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Hermann Cohen, "), _c('i', [_vm._v("System der Philosophie, Zweiter Teil: Ethik des reinen Willens")]), _vm._v(" (Berlin: Bruno Cassirer, 1904; repr. in "), _c('i', [_vm._v("Werke")]), _vm._v(" 7).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("JS")]), _vm._v(" 1–3")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Hermann Cohen, "), _c('i', [_vm._v("Hermann Cohens Jüdischen Schriften")]), _vm._v(", vols. 1–3, ed. Bruno Strauss with an introduction by Franz Rosenzweig (Berlin: C. A. Schwetschke & Sohn/Verlagsbuchhandlung, 1924).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("RoR")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Hermann Cohen, "), _c('i', [_vm._v("Religion of Reason: Out of the Sources of Judaism")]), _vm._v(", trans. Simon Kaplan (Atlanta, GA: Scholars’ Press, 1995).")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f02f70d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253039767_Abbreviations.vue
// module id = 78
// module chunks = 0